// retireBy=2023-04-15
// retireTicket=https://jira.cvent.com/browse/FLEX-85059
import { releaseAtVariant } from '../shared';
export const isFlexRegistrationPathLocalizationEnabled = releaseAtVariant('flex_enable_registration_paths_localization', 1);
